import React from 'react'
import { T } from '@transifex/react'

import { createContainerRoutesMap } from './assets'
import { createCompostingRegistriesRouteMap } from './composting-registries'
import { createContactRoutesMap } from './contacts'
import { createPropertyRoutesMap } from './property'
import { createPropertyGroupsRouteMap } from './property-groups'
import { createSharedCollectionPointsRouteMap } from './shared-collection-points'
import { createStandaloneContactsRouteMap } from './standalone-contacts'
import { createSubscriptionRoutesMap } from './subscriptions'
import { pathJoin } from '../../../utils'

export const createCustomerManagementRouteMap = (prefix: string) => ({
  // 3.1.38 Part B: the Report relocation wizard. Registered ahead of the
  // list/detail sections so its route never falls through to a detail
  // matcher.
  'report-relocation': pathJoin(prefix)('report-relocation').chainWithTitle({
    title: <T _str="Report relocation" />,
    breadCrumbTitle: <T _str="Report relocation" />,
  }),
  'inquiry-management': pathJoin(prefix)('inquiry-management').chain,
  // The composting register's canonical detail view — reached from the
  // Property tab and the Individual tab alike (see the map's own comment).
  'composting-registries': pathJoin(prefix)(
    'composting-registries'
  ).chainMapAuto(createCompostingRegistriesRouteMap, {
    title: <T _str="Composting register" />,
    breadCrumbTitle: <T _str="Composting register" />,
  }),
  'property-groups': pathJoin(prefix)('property-groups').chainMapAuto(
    createPropertyGroupsRouteMap,
    {
      title: <T _str="All Property Groups" />,
      breadCrumbTitle: <T _str="All Property Groups" />,
    }
  ),
  properties: pathJoin(prefix)('properties').chainMapAuto(
    createPropertyRoutesMap,
    {
      title: <T _str="All Properties" />,
      breadCrumbTitle: <T _str="All Properties" />,
    }
  ),
  contacts: pathJoin(prefix)('contacts').chainMapAuto(createContactRoutesMap, {
    title: <T _str="All Contacts" />,
    breadCrumbTitle: <T _str="All Contacts" />,
  }),
  // Umbrella title, ADR-0001 style (see 'shared-collection-points' below): the
  // section holds two sibling registries — Individuals (`ContactDef`) and
  // Companies — so no single entity noun fits it, and "Contacts" is not
  // available because the legacy per-property contacts entity above owns that
  // word. The leaf lists carry "All Individuals" / "All Companies".
  'standalone-contacts': pathJoin(prefix)('standalone-contacts').chainMapAuto(
    createStandaloneContactsRouteMap,
    {
      title: <T _str="Individuals & Companies" />,
      breadCrumbTitle: <T _str="Individuals & Companies" />,
    }
  ),
  // ADR-0001 umbrella naming: the section lists every shared service
  // (residential + collection points), so it is not called "collection points".
  'shared-collection-points': pathJoin(prefix)(
    'shared-collection-points'
  ).chainMapAuto(createSharedCollectionPointsRouteMap, {
    title: <T _str="Shared services" />,
    breadCrumbTitle: <T _str="Shared services" />,
  }),
  agreements: pathJoin(prefix)('agreements').chainMapAuto(
    createContainerRoutesMap,
    {
      title: <T _str="Agreement" />,
      breadCrumbTitle: <T _str="Agreement" />,
    }
  ),
  subscriptions: pathJoin(prefix)('subscriptions').chainMapAuto(
    createSubscriptionRoutesMap,
    {
      title: <T _str="SMS/Email service" />,
      breadCrumbTitle: <T _str="SMS/Email service" />,
    }
  ),
})
